import { supabase } from './supabase.js';

/** Código de referido del perfil (columna `referral_code`). */
export async function fetchMyReferralCode(userId) {
  if (!userId) return { code: null, error: 'no_user' };
  const { data, error } = await supabase.from('profiles').select('referral_code').eq('id', userId).maybeSingle();
  if (error) return { code: null, error: error.message };
  return { code: data?.referral_code ?? null, error: null };
}

/** Registra referido una vez (RPC `claim_referral`). */
export async function claimReferralCode(code) {
  const c = String(code ?? '').trim();
  if (c.length < 4) return { ok: false, error: 'invalid_code' };
  const { data, error } = await supabase.rpc('claim_referral', { p_code: c });
  if (error) return { ok: false, error: error.message };
  if (data && data.ok === false) return { ok: false, error: data.code || data.message || 'claim_failed' };
  return { ok: true, data, error: null };
}
